import { RosterController } from './RosterController';

export const rosterService = new RosterController( {
    // ...
} );
